module.exports = __webpack_public_path__ + "static/media/3b.1eb85745.jpg";